import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TypeformEmbed = ({ triggerFeedback, setTriggerFeedback }) => {
  const app = useSelector((state) => state.app);
  const { i18n } = useTranslation();
  const feedbackButtonRef = useRef(null);

  // useEffect(() => {
  //   console.log("triggerFeedback",triggerFeedback)
  // }, [triggerFeedback])

  // Load the Typeform script when the component mounts
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script and feedback state only when the component unmounts
      document.body.removeChild(script);
      setTriggerFeedback(false); // Reset feedback trigger when component is cleaned up.
    };
  }, [feedbackButtonRef, setTriggerFeedback]);

  // Update the feedback button text when the language changes
  useEffect(() => {
    const feedbackButton = feedbackButtonRef.current?.querySelector(
      "button[data-tf-slider]"
    );
    if (feedbackButton) {
      feedbackButton.textContent = i18n.t("Top_Bar.Feedback");
    }
  }, [app.language, i18n]);

  // Handle the feedback button trigger whenever the feedback button is clicked
  useEffect(() => {
    if (triggerFeedback && feedbackButtonRef.current) {
      const feedbackButton = feedbackButtonRef.current.querySelector(
        "button[data-tf-slider]"
      );
      if (feedbackButton) {
        feedbackButton.click();
        setTriggerFeedback(false); // Reset after the button is clicked to allow multiple triggers.
      }
    }
  }, [triggerFeedback, setTriggerFeedback]);

  return (
    <div
      ref={feedbackButtonRef}
      data-tf-live="01HT39ENK9G29AY5SQRSPAAW8R"
      style={{ display: "none" }}
    ></div>
  );
};

export default TypeformEmbed;
